import { getApiData } from "../utils/APIHelper";

const ENDPOINTS = {
  BY_PROJECT: (projectId) => `api/shop-drawings/project/${projectId}`,
};

export const getShopDrawingsByProject = async (projectId) => {
  try {
    return await getApiData(ENDPOINTS.BY_PROJECT(projectId), "GET", {});
  } catch (error) {
    console.error("Get shop drawings error:", error);
    throw error;
  }
};
